import { RootState, SpecialOfferReceiptState } from '@/types/store'
import { Module } from 'vuex'

import { getters } from './getters'
import { actions } from './actions'
import { mutations } from './mutations'

import { initSpecialOffer } from '../special-offer'

const state: SpecialOfferReceiptState = {
  receiptType: 'unchecked',
  isSpecialOfferReceiptLoading: false,
  specialOfferReceipt: {
    id: -1,
    specialOfferId: '',
    specialOffer: initSpecialOffer,
    userId: -1,
    transactionId: -1,
    createdAt: '',
    updatedAt: '',
    deletedAt: null,
    importedAt: '',
    imagePrefix: '',
    phone: '',
    chainStoreName: '',
    storeName: '',
    itemName: '',
    itemNameSecond: '',
    dateTime: '',
    sum: -1,
    ngReason: null,
    otherNgReason: '',
    systemOkedAt: null,
    linkerOkedAt: null,
    leaderOkedAt: null,
    systemNgedAt: null,
    linkerNgedAt: null,
    leaderNgedAt: null,
    needsLeaderCheck: false,
    okedByLinkerId: null,
    okedByLeaderId: null,
    ngedByLinkerId: null,
    ngedByLeaderId: null,
    duplicatedId: null,
    closedAt: null,
    imageUrl: null,
  },
  specialOfferReceipts: [],
  total: 0,
}

export const specialOfferReceipt: Module<
  SpecialOfferReceiptState,
  RootState
> = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
